var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7443 13.0097L11.0347 10.2989C13.0622 7.58945 12.5093 3.74937 9.79988 1.72186C7.09043 -0.305644 3.25034 0.24719 1.22284 2.95664C-0.804668 5.6661 -0.251833 9.50618 2.45762 11.5337C4.63408 13.1624 7.6234 13.1624 9.79988 11.5337L12.5107 14.2445C12.8514 14.5852 13.4037 14.5852 13.7443 14.2445C14.085 13.9038 14.085 13.3515 13.7443 13.0109L13.7443 13.0097ZM6.15134 11.0105C3.74331 11.0105 1.79123 9.0584 1.79123 6.65037C1.79123 4.24233 3.74331 2.29026 6.15134 2.29026C8.55938 2.29026 10.5115 4.24233 10.5115 6.65037C10.5089 9.05731 8.55831 11.0079 6.15134 11.0105Z",
    fill: "#969BA9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchGrey);
export default __webpack_public_path__ + "static/media/SearchGrey.ef27ba2d2d59834dbf54ea1782f0231e.svg";
export { ForwardRef as ReactComponent };